import ScorecardBg from "../assets/images/scorecard-bg.jpeg"

const SpinningCard = () => {
    return (
        <div
          className="flex justify-center items-center animate-spin-z bg-scorecard"
        >
            <img src={ScorecardBg} className="h-[270px] md:h-[330px] w-auto"/>
        </div>
    )
}

export default SpinningCard
